import { Col, Row } from "taltech-styleguide";
import { BarChartStatistics, FacetedChart } from "@components-common/charts";
import { Page } from "@components-common/layouts";

export const AnalyticsScreen: React.FC<any> = () => {
  return (
    <Page title="Analytics">
      <Row>
        <Col sm={12} md={6} xl={4} className="pe-3">
          <BarChartStatistics
            id="chart_users_per_role"
            subTitle="Users per Role"
            seriesName="Users"
            urlEndpoint="/analyticsms/user-analytics/get-users-count-per-role"
            yAxisProperty="count"
            xAxisProperty="role"
          />
        </Col>
        <Col sm={12} md={6} xl={4} className="pe-3">
          <BarChartStatistics
            id="chart_courses_per_status"
            subTitle="Courses Statuses"
            seriesName="Courses"
            urlEndpoint="/analyticsms/course-analytics/get-courses-count"
            yAxisProperty="count"
            xAxisProperty="state"
          />
        </Col>
        <Col sm={12} md={6} xl={4} className="pe-3">
          <BarChartStatistics
            id="chart_assignments_per_course"
            subTitle="Assignment Submissions"
            seriesName="Assignments"
            urlEndpoint="/analyticsms/course-analytics/get-assignment-submissions-count"
            yAxisProperty="count"
            xAxisProperty="courseName"
          />
        </Col>
        <Col sm={12} md={6} className="pe-3">
          <FacetedChart
            id="chart_lecturer_student_count_per_course"
            firstBarData={{
              name: "Students",
              propName: "studentCount",
            }}
            secondBarData={{
              name: "Lecturers",
              propName: "lecturerCount",
            }}
            xAxisProperty="courseName"
            title="Student and Lecturers"
            subTitle="Students and Lecturers per course"
            urlEndpoint="analyticsms/course-analytics/get-lecturer-student-count-by-course"
          />
        </Col>
        <Col sm={12} md={6} className="pe-3">
          <FacetedChart
            id="chart_assignment_submissions_by_students"
            firstBarData={{
              name: "Active",
              propName: "activeCount",
            }}
            secondBarData={{
              name: "Submitted",
              propName: "submittedCount",
            }}
            xAxisProperty="courseName"
            title="Student Assignments"
            subTitle="Course Assignment Statuses"
            urlEndpoint="analyticsms/course-analytics/get-assignment-members-state-count-per-course"
          />
        </Col>
      </Row>
    </Page>
  );
};
